import Header from '@/components/Header'
import Footer from '@/components/Footer'
import WhatsAppFloat from '@/components/WhatsAppFloat'
import Breadcrumb from '@/components/Breadcrumb'
import MetaTags from '@/components/MetaTags'

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <MetaTags
        title="Termos e Condições - FotoLivro Store"
        description="Leia nossos Termos e Condições para entender as regras e diretrizes sobre a utilização dos serviços da FotoLivro Store."
        type="website"
      />
      <Header />
      <Breadcrumb />
      <main className="flex-1 bg-background">
        <section className="py-20">
          <div className="container mx-auto px-4 max-w-4xl">
            <h1 className="text-4xl md:text-5xl font-bold text-center mb-8 text-foreground">
              Termos e Condições
            </h1>

            <div className="prose prose-lg max-w-none text-foreground space-y-8">
              <section>
                <p className="text-muted-foreground leading-relaxed">
                  LEIA ATENTAMENTE O PRESENTE TERMO DE ADESÃO ANTES DE ACESSAR
                  OU UTILIZAR OS SERVIÇOS DA PLATAFORMA ISOHUB. A PERMANÊNCIA
                  NESTE AMBIENTE VIRTUAL IMPLICA AUTOMATICAMENTE NA LEITURA E
                  ACEITAÇÃO DOS PRESENTES TERMOS.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">DEFINIÇÕES</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  1.1. Para os fins deste Termo de Adesão ("Termo"), são
                  consideradas as seguintes definições:
                </p>
                <div className="space-y-3 pl-4">
                  <p className="text-muted-foreground leading-relaxed">
                    <strong>(a) Álbum:</strong> produto final físico ou digital,
                    composto por imagens impressas ou digitais, diagramadas e
                    personalizadas de acordo com as preferências do Contratante;
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    <strong>(b) "Contratada":</strong> PH Tecnologia LTDA.,
                    pessoa jurídica prestadora dos Serviços objeto deste Termo;
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    <strong>(c) "Contratante":</strong> pessoa física ou
                    jurídica que adere ao presente Termo para a contratação dos
                    Serviços;
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    <strong>(d) "Imagens":</strong> arquivos digitais de fotos
                    ou ilustrações enviadas pelo Contratante para utilização no
                    Álbum;
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    <strong>(e) "Plataforma":</strong> plataforma online da
                    Contratada, utilizada para a contratação e criação do Álbum,
                    incluindo o upload e edição de Imagens, diagramação e
                    personalização do layout;
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    <strong>(f) "Serviço":</strong> serviço de criação de álbuns
                    personalizados oferecido pela Contratada, abrangendo desde a
                    escolha do álbum no Site até a entrega do produto final ao
                    Contratante;
                  </p>
                  <p className="text-muted-foreground leading-relaxed">
                    <strong>(g) "Site":</strong> https://fotolivro.store/
                    utilizado para a contratação do Serviço e acesso à
                    Plataforma.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">OBJETO</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  2.1. O presente Termo de Adesão ("Termo") tem por objeto
                  regular a contratação do serviço de álbuns personalizados
                  ("Serviço") oferecido pela PH Tecnologia LTDA., inscrita no
                  CNPJ sob o nº 40.524.684/0001-45, com sede na Rua Imaculada
                  Conceição, 1430, Prado Velho, Curitiba/PR, CEP: 80.215-182,
                  doravante denominada "FOTOLIVRO STORE" (ou "Contratada"),
                  abrangendo desde a escolha do álbum no site
                  www.fotolivromaratona.com.br ("Site") até a entrega do produto
                  final ("Álbum") ao cliente ("Contratante").
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  2.2. O Serviço inclui:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                  <li>
                    Seleção do tipo e modelo do Álbum pelo Contratante no Site;
                  </li>
                  <li>
                    Cadastro do Contratante na plataforma online da Contratada
                    ("Plataforma");
                  </li>
                  <li>
                    Realização do pagamento conforme as condições estabelecidas
                    no Site e neste Termo;
                  </li>
                  <li>
                    Acesso à Plataforma para upload das imagens digitais a serem
                    utilizadas no Álbum ("Imagens");
                  </li>
                  <li>
                    Seleção ou confirmação da seleção das Imagens a serem
                    impressas;
                  </li>
                  <li>Aprovação do layout e design do Álbum;</li>
                  <li>
                    Produção física do Álbum pela Contratada ou por terceiros
                    contratados e envio ao endereço informado pelo Contratante.
                  </li>
                </ul>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  2.3. O serviço poderá ser oferecido sob diferentes marcas
                  comerciais ou labels associadas à PH Tecnologia, como
                  FotoLivro Formatura, FotoLivro Maratona, Meu Álbum de Viagem,
                  entre outras. A depender do domínio ou marca sob a qual o
                  serviço for adquirido, o Contratante poderá ser redirecionado
                  para a Plataforma correspondente. Após a consolidação das
                  marcas sob o domínio principal www.fotolivro.store, a
                  comunicação poderá ser unificada.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  2.4. A Contratada poderá, a seu critério, disponibilizar
                  diferentes modelos de contratação do Serviço, com variações
                  nos itens inclusos, condições de pagamento e prazos de
                  entrega. Essas variações visam atender a diferentes perfis de
                  clientes e serão divulgadas previamente no Site.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  DO PROCESSO DE CRIAÇÃO E APROVAÇÃO
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  3.1. O Contratante poderá optar por:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                  <li>
                    Selecionar as Imagens a serem utilizadas no Álbum utilizando
                    as ferramentas disponibilizadas pela Plataforma;
                  </li>
                  <li>
                    Contratar o serviço de curadoria de fotos oferecido pela
                    Contratada ou por terceiros, para seleção profissional das
                    Imagens;
                  </li>
                  <li>
                    Contratar o serviço de edição e design do Álbum, com direito
                    a até duas provas online para aprovação do layout. Este
                    serviço não se aplica a todos os produtos, como por exemplo
                    à impressão de fotos, que não possuem diagramação.
                  </li>
                </ul>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  3.2. Para a Linha Magnifique, o cliente terá direito a prova
                  livre, sem um limite fixo de revisões, permitindo ajustes
                  contínuos até a aprovação final. Esta condição será aplicada
                  conforme especificado nos serviços contratados e descritos na
                  plataforma no momento da compra.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  3.3. A Contratada se compromete a disponibilizar na Plataforma
                  as ferramentas e o suporte técnico necessários para que o
                  Contratante possa subir as imagens, inserir descrições e
                  títulos, e indicar preferências para o Álbum, que será
                  posteriormente editado e diagramado pela equipe da Contratada,
                  conforme o serviço adquirido.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  DA IMPRESSÃO E ENTREGA
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  4.1. A impressão do Álbum será realizada por empresas
                  terceirizadas contratadas pela Contratada, especializadas em
                  impressão e encadernação de álbuns fotográficos.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  4.2. A Contratada se compromete a:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                  <li>
                    Garantir a qualidade da impressão do Álbum, dentro dos
                    padrões e especificações técnicas da empresa terceirizada
                    responsável pela impressão;
                  </li>
                  <li>
                    Realizar a entrega do Álbum no endereço indicado pelo
                    Contratante, sem custos adicionais de frete para entregas
                    dentro do território nacional.
                  </li>
                </ul>
                <p className="text-muted-foreground leading-relaxed">
                  4.3. O prazo estimado para produção e entrega do Álbum será
                  informado no momento da contratação, na página de finalização
                  da compra do Serviço no Site, podendo variar conforme a
                  demanda, a logística dos parceiros e outros fatores externos.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">DAS TAXAS E PRAZOS</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  5.1. A Contratada poderá cobrar do Contratante:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                  <li>
                    Taxa de atualização ou manutenção do projeto do Álbum, caso
                    o Contratante não finalize o processo de criação e aprovação
                    do layout dentro de um prazo determinado, contado a partir
                    da data da compra do Serviço;
                  </li>
                  <li>
                    Taxa adicional por cada prova extra de layout solicitada
                    pelo Contratante, além do número de provas incluso no plano
                    ou pacote contratado.
                  </li>
                </ul>
                <p className="text-muted-foreground leading-relaxed">
                  5.2. Os valores e as condições de cobrança das taxas previstas
                  neste item serão informados no Site e na Plataforma, no
                  momento da contratação do Serviço.
                </p>
              </section>

              <section className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded">
                <h2 className="text-2xl font-bold mb-4">
                  DAS POLÍTICAS DE USO E DIREITOS AUTORAIS
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  6.1. O Contratante declara ser o único e exclusivo titular dos
                  direitos autorais sobre as Imagens enviadas para a Plataforma,
                  assumindo total responsabilidade por eventual violação de
                  direitos de terceiros.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  6.2. É terminantemente proibido solicitar a remoção de marcas
                  d'água das imagens utilizadas no álbum. Essa proibição visa
                  garantir a proteção da identidade visual e da propriedade
                  intelectual das imagens enviadas à plataforma. Qualquer
                  tentativa de remoção será considerada violação deste termo e
                  poderá resultar na suspensão do serviço.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  6.3. No caso de utilização de cupons de desconto promocionais
                  para a compra do Serviço, o Contratante autoriza a Contratada
                  a utilizar as Imagens do Álbum para fins de divulgação e
                  marketing, incluindo a produção de álbuns de mostruário para
                  exibição em feiras, congressos, exposições e eventos
                  similares, com a devida atribuição de autoria ao Contratante.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  6.4. O crédito das Imagens utilizadas no Álbum será atribuído
                  conforme indicado pelo Contratante, podendo constar como
                  "Acervo Pessoal" ou com a identificação do fotógrafo ou
                  estúdio responsável pelas Imagens, conforme especificado pelo
                  Contratante no momento da contratação do Serviço.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  DO MANUAL DO CLIENTE
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  7.1. A Contratada se compromete a disponibilizar ao
                  Contratante, através do Site ou da Plataforma, um manual com o
                  passo a passo do processo de contratação e criação do Álbum,
                  incluindo informações detalhadas sobre os prazos, as taxas
                  adicionais, os canais de atendimento e suporte ao cliente, e
                  outras informações relevantes para a utilização do Serviço.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  DO SUPORTE E ATENDIMENTO
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  8.1. A Contratada se compromete a fornecer ao Contratante
                  suporte e atendimento através dos canais de comunicação
                  disponibilizados no Site e na Plataforma, como chat online,
                  e-mail e telefone.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  8.2. O prazo máximo para resposta às solicitações e dúvidas do
                  Contratante será de até 3 (três) dias úteis, salvo em casos de
                  força maior ou circunstâncias excepcionais.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  DAS RESPONSABILIDADES
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  9.1. A Contratada não se responsabiliza por eventuais
                  problemas na impressão do Álbum decorrentes do envio de
                  Imagens de baixa qualidade ou resolução pelo Contratante,
                  sendo recomendável o envio de arquivos em alta resolução e nos
                  formatos especificados no Site e na Plataforma.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  9.1.1. A Contratada utilizará, sempre que possível, recursos
                  tecnológicos, incluindo softwares com inteligência artificial,
                  para aprimoramento da qualidade das imagens recebidas. No
                  entanto, não é possível garantir resultados 100%
                  satisfatórios. Em tais casos, e a critério da Contratada,
                  imagens que apresentarem baixa qualidade poderão ser evitadas
                  no layout ou utilizadas em tamanho reduzido. O Contratante
                  terá acesso à prova final do Álbum, podendo aprovar ou
                  solicitar ajustes antes da impressão definitiva.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  9.2. O cliente é exclusivamente responsável pela titularidade
                  das imagens enviadas. Ao aceitar este termo, o cliente declara
                  expressamente que detém todos os direitos necessários sobre as
                  imagens utilizadas, incluindo direitos de uso e reprodução.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  9.3. A Contratada não se responsabiliza por atrasos na entrega
                  do Álbum decorrentes de fatores externos e alheios ao seu
                  controle, como greves, paralisações, catástrofes naturais,
                  problemas logísticos dos Correios ou outras empresas de
                  transporte, ou outras circunstâncias imprevisíveis.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  9.4. O Contratante é responsável por conferir todos os
                  detalhes do Álbum, como a seleção das Imagens, a diagramação,
                  o layout e a ortografia dos textos, antes da aprovação final
                  do projeto. Após a aprovação final, não será possível realizar
                  qualquer alteração no Álbum, salvo mediante pagamento de taxa
                  adicional, se disponível.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  9.5. A Contratada não se responsabiliza por qualquer infração
                  de direitos autorais ou de imagem cometida pelo Contratante ao
                  enviar Imagens de terceiros sem a devida autorização. O
                  Contratante isenta a Contratada de qualquer responsabilidade
                  por danos, perdas ou prejuízos decorrentes de tais infrações.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  DA PROPRIEDADE INTELECTUAL
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  10.1. Não-aquisição de Direitos. O contratante não adquirirá
                  nenhum direito de propriedade sobre os serviços e conteúdos da
                  FOTOLIVRO STORE, exceto quando haja outorga expressa neste
                  Termos de Uso ou mediante determinação legal.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  VIOLAÇÃO DIREITO AUTORAL
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  11.1. Infringência de Direitos. Alegações de infringência de
                  direito autoral de qualquer conteúdo disponível na FOTOLIVRO
                  STORE devem ser encaminhadas por meio do e-mail:
                  contato@fotolivro.store
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">
                  ALTERAÇÃO DOS TERMOS
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  12.1. A FOTOLIVRO STORE poderá alterar estes Termos a qualquer
                  momento, mediante disponibilização da versão atualizada neste
                  local, de modo que, se o Contratante continuar a acessar ou
                  usar os serviços após essa postagem, seu consentimento aos
                  Termos atualizados será presumido, caso não concorde com as
                  alterações, cesse o uso imediatamente.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  12.2. Termos adicionais poderão se aplicar a determinados
                  documentos, serviços, materiais, comunicações e outras
                  informações tais como condições para um evento, atividade ou
                  promoção em particular, e esses termos adicionais serão
                  divulgados em relação aos respectivos serviços.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  12.1.1. Termos adicionais são complementares e considerados
                  parte integrante destes Termos. 12.1.2. Termos adicionais
                  prevalecerão sobre estes Termos em caso de conflito das
                  disposições.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">DISPOSIÇÕES GERAIS</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  13.1. A tolerância de eventual descumprimento de qualquer
                  condição destes Termos não constituirá renúncia ou novação nem
                  impedirá a exigência destes condições a qualquer tempo.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  13.2. Se alguma disposição destes Termos for julgada
                  inaplicável, ilegal, inválida, inexequível ou sem efeito, a
                  legalidade, validade e exequibilidade das demais disposições
                  contidas não serão afetadas.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  13.2.1. Nesse caso, as partes substituirão a disposição
                  ilegal, inválida ou inexequível, ou parte dela, por outra que
                  seja legal, válida e exequível e que, na máxima medida
                  possível, tenha efeito similar à disposição tida como ilegal,
                  inválida ou inexequível para fins de conteúdo e finalidade dos
                  presentes Termos.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  13.3. Todos os registros e guarda de dados realizados no
                  ambiente do Site e serviços, serão realizados e catalogados
                  com base no horário oficial de Brasília, salvo disposição em
                  contrário.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  13.4. Lei e foro. Estes Termos serão regidos e interpretados
                  exclusivamente de acordo com as leis do Brasil. Qualquer
                  reclamação, conflito ou controvérsia que surgir deste contrato
                  ou a ele relacionada, inclusive que diga respeito a sua
                  validade, interpretação ou exequibilidade, será solucionada
                  exclusivamente pelos tribunais do foro da Comarca de Curitiba,
                  do Estado do Paraná , em detrimento de qualquer outro, por
                  mais privilegiado seja.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  13.5. Assim, com a concordância do usuário, estes termos
                  regerão a relação contratual estabelecida entre as partes,
                  podendo sempre ser consultada a data da última atualização no
                  início deste documento.
                </p>
              </section>

              <section className="border-t pt-8 mt-8">
                <p className="text-muted-foreground text-center">
                  <strong>Curitiba, 10 de outubro de 2025.</strong>
                  <br />
                  PH Tecnologia LTDA - FotoLivroStore
                  <br />
                  CNPJ nº 40.524.684/0001-45
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  )
}

export default TermsAndConditions
